import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Typography, Box, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../locales/keys';
import { postMessageOfferFlow } from '../../../utils/postMessage';
import useSubscriptionFlowAnalyticsParams from '../../../common/hooks/useSubscriptionFlowAnalyticsParams';
import events from '../../../common/events/events';

const useStyles = makeStyles(() => ({
  paperContainer: {
    backgroundColor: '#15151E',
    borderRadius: '6px',
    border: '2px solid #ffd300',
  },

  offerTitle: {
    fontFamily: 'Formula1-Bold',
    fontSize: '18px',
    paddingLeft: '0px',
    paddingTop: '20px',
    paddingBottom: '15px',
  },

  contentContainer: {
    direction: 'row',
    justifyContent: 'flex-start',
  },

  offerIcon: {
    paddingLeft: '8px',
    display: 'flex',
    margin: '6px',
    width: '20px',
    height: '20px',
    backgroundColor: '#ffd300',
    borderRadius: '50%',
    fontSize: '14px',
    textAlign: 'center',
  },
  offerMessage: {
    padding: '5px 0px',
    justifyContent: 'flex-start',
    fontSize: '17px',
    color: '#ffffff',
    textTransform: 'none',
  },
  offerCta: {
    position: 'absolute',
    right: 0,
    marginRight: '10px',
    marginTop: '3px',
    textTransform: 'uppercase',
    justifyContent: 'center',
    color: '#ffd300',
    borderBottom: 'none',
    textDecoration: 'none',
    '&:hover': {
      borderBottom: '#FF0000 solid 2px',
      cursor: 'pointer',
      color: '#ffd300',
      textDecoration: 'none',
    },
  },
}));

export const RetentionOfferMessage = ({
  eligibleForRetention,
  displayRetentionOfferHandler,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [language, subscriptionType, subscriptionPackage] =
    useSubscriptionFlowAnalyticsParams();

  const retentionOfferHandler = () => {
    displayRetentionOfferHandler(true);
    postMessageOfferFlow('', {
      ...events.seeOffer.cta,
      subscriptionPackage,
      subscriptionType,
      language,
    });
  };

  if (!eligibleForRetention) return null;
  return (
    <>
      <Grid container className={classes.offerTitleContainer}>
        <Typography className={classes.offerTitle}>
          {t(LocaleKeys.retention.subscriptionItemOfferTitle)}
        </Typography>
      </Grid>
      <Grid container className={classes.paperContainer}>
        <Grid container className={classes.contentContainer}>
          <Box className={classes.offerIcon}>
            {t(LocaleKeys.retention.subscriptionItemOfferIcon)}
          </Box>
          <Typography variant="h4" className={classes.offerMessage}>
            {t(LocaleKeys.retention.subscriptionItemOfferText)}
          </Typography>
          <Link
            disableRipple
            disableFocusRipple
            size="small"
            className={classes.offerCta}
            onClick={retentionOfferHandler}
          >
            {t(LocaleKeys.retention.subscriptionItemOfferCTA)}
          </Link>
        </Grid>
      </Grid>
    </>
  );
};

export default RetentionOfferMessage;
